import styled from "styled-components"

export const Separator = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.backgroundModifier.accent};
`
